function initConfirmationModalSubmit() {
  let confirmationModalBtn    = $('#confirmationModalBtn');
  let confirmationModalSubmit = $('#confirmationModal input[type=submit]');
  let confirmationModalForm   = confirmationModalSubmit.closest('form');

  if (confirmationModalBtn.length && confirmationModalSubmit.length) {
    confirmationModalForm.on('keypress', function(event) {
      let key = event.charCode || event.keyCode || 0;
      if (key == 13) {
        event.preventDefault();
      }
    });

    confirmationModalBtn.on('click', function() {
      $('#confirmationModal').modal('show');
    });

    confirmationModalSubmit.on('click', function() {
      $('#confirmationModal').modal('hide');
    });
  };
};

function initForeignConfirmationModal() {
  let countrySelectorId = '#users_profile_user_attributes_country';

  if ($(countrySelectorId).length) {
    $(document).on('change', countrySelectorId, function() {
      initConfirmationModalSubmit();
      let currentCountryIsForeign = $(countrySelectorId).val() !== 'FR';

      if ($('#submitWithConfirmation').length) {
        if (!currentCountryIsForeign) {
          $('#submitWithoutConfirmation').addClass('d-none');
          $('#submitWithConfirmation').removeClass('d-none');
        }
      }
    });
  }
};

$(document).ready(function() {
  initForeignConfirmationModal();
  initConfirmationModalSubmit();
});
